import { z } from 'zod';
import { MEETING_EVENT_ORDER_BY_FIELDS, } from '../../../meeting-events/index.js';
import { createSortablePaginationSchema, dateFilterSchema, idFilterSchema, } from '../../../shared/index.js';
/**
 * Query schema for searching member meetings.
 * Filters meetings by meeting bodies where the user has an active seat.
 */
export const memberMeetingsSearchSchema = createSortablePaginationSchema(MEETING_EVENT_ORDER_BY_FIELDS).extend({
    id: idFilterSchema.optional(),
    meetingBodyId: idFilterSchema.optional(),
    date: dateFilterSchema.optional(),
});
/**
 * Request schema for member-authored private minutes notes.
 */
export const memberMeetingMinutesNoteCreateSchema = z.object({
    content: z.string().min(1, 'Content is required'),
});
/**
 * Request schema for updating member-authored private minutes notes.
 */
export const memberMeetingMinutesNoteUpdateSchema = z.object({
    content: z.string().min(1, 'Content is required'),
});
